import React, { useContext, useEffect, useMemo, useState, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { withCustomValidation, withError, ValidationGroup } from '@bingads-webui-react/validation';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { ValidatedFinalUrl as UrlInput } from '@bingads-webui-campaign-react/validated-url-input';


const ValidatedFinalUrl = withControlErrorHandling(withUnvalidatedControlErrors(withError(withCustomValidation(UrlInput))));

export const FinalUrl = ({
  i18n,
  finalUrlsObj,
  containerClassName,
  setCopilotFinalUrl,
  isAdGridEditorMode,
}) => {
  const activity = useContext(ActivityContext);
  const [validationState, setValidationState] = useState({});
  const [updatedCopilotFinalUrl, setUpdatedCopilotFinalUrl] = useState(false);

  const updateValidationState = (result) => {
    setValidationState(result);
  };

  const notifyCopilotFinalURLchange = useCallback(() => {
    const isValid = _.result(validationState, 'isValid', false);
    const finalUrls = _.result(validationState, ['data', 'FinalUrls'], undefined);
    const finalUrl = _.first(finalUrls);

    if (isValid) {
      if (activity) {
        activity.signal(`[VideoAdsCopilot] - Final URL changed to ${finalUrl}`);
      }

      setCopilotFinalUrl(finalUrl);
      setUpdatedCopilotFinalUrl(true);
    }
  }, [activity, validationState, setCopilotFinalUrl]);

  const handleKeyUp = useCallback((e) => {
    const { key } = e;
    if (key === 'Enter') {
      notifyCopilotFinalURLchange();
    }
  }, [notifyCopilotFinalURLchange]);

  const additionalProperties = useMemo(() => ({ onBlur: notifyCopilotFinalURLchange, onKeyUp: handleKeyUp }), [notifyCopilotFinalURLchange, handleKeyUp]);

  useEffect(() => {
    // for editor notify final url to trigger copilot on editor open
    if (isAdGridEditorMode && !updatedCopilotFinalUrl) {
      notifyCopilotFinalURLchange();
    }
  }, [isAdGridEditorMode, notifyCopilotFinalURLchange, updatedCopilotFinalUrl]);

  return (
    <ValidationGroup
      validationProps={{
        onValidate: updateValidationState,
      }}
    >
      <ValidatedFinalUrl
        containerClassName={classNames(containerClassName, 'final-url-container')}
        i18n={i18n}
        validationProps={{
          data: finalUrlsObj,
          initialValue: finalUrlsObj,
        }}
        validateOnRender
        additionalProperties={additionalProperties}
      />
    </ValidationGroup>
  );
};

FinalUrl.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  finalUrlsObj: PropTypes.shape({}).isRequired,
  containerClassName: PropTypes.string,
  setCopilotFinalUrl: PropTypes.func.isRequired,
  validationProps: PropTypes.shape({}).isRequired,
  isAdGridEditorMode: PropTypes.bool,
};

FinalUrl.defaultProps = {
  containerClassName: '',
  isAdGridEditorMode: false,
};
